import { createSlice } from "@reduxjs/toolkit";
import { loadNotifications } from "./notification-actions";

const initialState = {
  list: [],
  count: 0,
  event6List: [],
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addNotification(state, action) {
      state.list.push(action.payload);
      state.count++;
    },
    addNotifications(state, action) {
      return {
        list: [...state.list, ...action.payload],
        count: state.count + action.payload.length,
      };
    },
    removeNotification(state, action) {
      state.list.splice(action.payload, 1);
      state.count--;
    },
    addToLocalStorage(state) {
      localStorage.setItem("notifications", JSON.stringify(state.list));
    },
    setNotifications(state, action) {
      state.list = action.payload;
      state.count = action.payload.length;
    },
    setEvent6Notifications(state, action) {
      state.event6List = action.payload;
    },
    addEvent6Notification(state, action) {
      state.event6List.push(action.payload);
    },
  },
  extraReducers(builder) {
    builder.addCase(loadNotifications.fulfilled, (state, action) => {
      state.list = action.payload;
      state.count = action.payload.length;
    });
  },
});

export const notificationActions = notificationSlice.actions;

export default notificationSlice;
